import { Handle, Position } from '@xyflow/react';

export function ValueNode({ data, sourcePosition = Position.Right }) {
  return (
    <div className="flow-node flow-node-value">
      <div className="flow-node-content">
        <div className="flow-node-title">{data.name}</div>
        <div className="flow-node-stats">
          {data.competencyCount} competencies
        </div>
      </div>
      <Handle
        type="source"
        position={sourcePosition}
        className="flow-handle"
      />
    </div>
  );
}
